import { createRoot, Root } from 'react-dom/client';
import { CellRendererProps } from 'tui-grid/types/renderer';

class CustomDetectAudioRenderer {
  element;
  currentKey;

  constructor(props: CellRendererProps) {
    this.currentKey = props.columnInfo.renderer.options?.data[props.rowKey];
    this.element = document.createElement('div') as HTMLDivElement;
    this.element.style.borderRadius = '5px';
    this.element.classList.add('custom-tag');
    const root = createRoot(this.element);
    if (this.currentKey?.detectEvent === 'fireAudio') {
      root.render(<span className={`detect-tag ${this.currentKey?.detectEvent}`}>화재감지</span>);
    } else if (this.currentKey?.detectEvent === 'helmetAudio') {
      root.render(<span className={`detect-tag ${this.currentKey?.detectEvent}`}>안전모 감지</span>);
    } else if (this.currentKey?.detectEvent === 'wanderAudio') {
      root.render(<span className={`detect-tag ${this.currentKey?.detectEvent}`}>진입 감지</span>);
    } else if (this.currentKey?.detectEvent === 'tumbleAudio') {
      root.render(<span className={`detect-tag ${this.currentKey?.detectEvent}`}>쓰러짐 감지</span>);
    } else {
      root.render(<span className='detect-tag'>-</span>);
    }
  }

  getElement() {
    return this.element;
  }
}

export default CustomDetectAudioRenderer;
